import { Mail, MapPin, Phone } from "lucide-react";
import { services, siteConfig } from "@latam-energy/content";
import { AppImage as Image } from "./AppImage";
import { AppLink as Link } from "./AppLink";
import { whatsappHref } from "@/lib/utils";

export function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="container grid gap-8 py-12 md:grid-cols-[1.2fr_1fr_1fr_1fr]">
        <div>
          <Image src="/assets/industrial/logo.png" alt="Latam Energy Services" width={320} height={72} className="h-16 w-auto rounded bg-white/95 p-1" />
          <p className="mt-5 max-w-sm leading-7 text-slate-300">Ingeniería, automatización, instrumentación y energía para operaciones industriales en Perú y Latinoamérica.</p>
        </div>
        <FooterList title="Empresa" links={[["Nosotros", "/nosotros"], ["Proyectos", "/proyectos"], ["Blog", "/blog"], ["Descargas", "/descargas"]]} />
        <FooterList title="Servicios" links={services.slice(0, 5).map((s) => [s.title, `/servicios/${s.slug}`])} />
        <div>
          <h2 className="text-sm font-extrabold uppercase text-cyan">Contacto</h2>
          <ul className="mt-4 grid gap-3 text-slate-300">
            <li className="flex gap-2"><Mail size={18} /> <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a></li>
            <li className="flex gap-2"><Phone size={18} /> <a href={`tel:${siteConfig.telephone.replace(/\s/g, "")}`}>{siteConfig.telephone}</a></li>
            <li className="flex gap-2"><MapPin size={18} /> {siteConfig.address}</li>
          </ul>
          <a className="btn btn-primary mt-5" href={whatsappHref()} rel="noopener noreferrer">WhatsApp</a>
        </div>
      </div>
      <div className="container flex flex-wrap justify-between gap-4 border-t border-white/10 py-5 text-sm text-slate-300">
        <span>© {new Date().getFullYear()} {siteConfig.companyName}. Todos los derechos reservados.</span>
        <span className="flex gap-4"><Link href="/politica-de-privacidad">Privacidad</Link><Link href="/terminos-y-condiciones">Términos</Link></span>
      </div>
    </footer>
  );
}

function FooterList({ title, links }: { title: string; links: (readonly [string, string])[] }) {
  return (
    <div>
      <h2 className="text-sm font-extrabold uppercase text-cyan">{title}</h2>
      <ul className="mt-4 grid gap-3 text-slate-300">
        {links.map(([label, href]) => <li key={href}><Link className="hover:text-white" href={href}>{label}</Link></li>)}
      </ul>
    </div>
  );
}
